/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 1373842098@qq.com
 * @Date: 2022-05-05 17:47:30
 * @LastEditors: linxi
 * @LastEditTime: 2025-06-23 14:15:29
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { notification } from 'antd'
import { size } from 'lodash'
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { List } from '../../../models/page'
import { CountryPageParams } from '../../../services/medical'
import { ThemeContext } from '../../../theme/ThemeContext'
import {
  logoutOrenableCommodity,
  pageCommodity,
  setSelectId,
} from '../../commodity/commoditySlice'
import { Columns } from '../../InventoryPrice/columns'
import { selectInsuranceArray } from '../../tenant/setting/TenentSettingSlice'
import { MedicalColumns } from '../Columns'
import { CountryPageValue, getCountryPage } from '../medicalSlice'
import { CurrentQuery } from './CurrentQuery'
import styles from './Materials.module.css'

export const WesternMedicine = () => {
  const theme = useContext(ThemeContext)
  const dispatch = useDispatch<RootDispatch>()

  const insuranceArray = useSelector(selectInsuranceArray)

  const [data, setData] = useState<List<CountryPageValue>>()

  const [queries, setQueries] = useState<CountryPageParams>({
    size: 10,
    current: 1,
  })

  useEffect(() => {
    if (insuranceArray && insuranceArray.length !== 0) {
      getData()
    }
    console.log(queries, insuranceArray)
  }, [queries, insuranceArray])

  const getData = () => {
    dispatch(
      getCountryPage({
        insuranceCode: insuranceArray[0].insuranceCode,
        ...queries,
        drugProdname: queries.name,
      })
    )
      .then(unwrapResult)
      .then((res) => {
        setData(res)
      })
  }

  return (
    <div className={styles.content}>
      <CurrentQuery
        code={1301}
        onValueChange={(vs) => {
          setQueries({ ...queries, ...vs })
        }}
        refresh={(()=>{
          getData()
        })}
      />
      <EditableList
        style={{ color: theme.tc3 }}
        className={styles.table}
        columns={MedicalColumns((id) => {
          console.log(id)
        }, queries.size * (queries.current - 1))}
        page={{
          size: queries.size,
          current: queries.current || 1,
          total: data?.total || 0,
          items: data?.records || [],
        }}
        onChangePage={(current, size?: number) => {
          setQueries({
            ...queries,
            current,
            size: size || 10
          })
        }}
      />
    </div>
  )
}
